import type { LobbyFormValues } from '../lobbies/lobbyForm';
import type { SeriesFormValues } from './seriesForm';

export function nextFixtureName(name: string): string {
  const match = /^(.*?)(?: #([0-9]+))?$/.exec(name.trim());
  return `${match?.[1] || 'Match'} #${Number(match?.[2] ?? 1) + 1}`;
}

export function nextSeriesForm(values: SeriesFormValues): SeriesFormValues {
  return {
    ...values,
    game_name: nextFixtureName(values.game_name),
    radiantTeamId: '',
    direTeamId: '',
    radiantStarters: [],
    direStarters: [],
    radiantCaptain: '',
    direCaptain: '',
    game_number: 1,
    initial_radiant_wins: 0,
    initial_dire_wins: 0,
  };
}

export function nextLobbyForm(values: LobbyFormValues): LobbyFormValues {
  return {
    ...values,
    game_name: nextFixtureName(values.game_name),
    radiantTeamId: '',
    direTeamId: '',
    selectedPlayerIds: [],
    radiant_series_wins: 0,
    dire_series_wins: 0,
  };
}
